/** How long the "Removed <name> from the group" toast offers Undo (CT-5573, assumption: confirm with Thomas/design). */
export const UNDO_WINDOW_MS = 6000;

/**
 * Safety net: the toast provider keeps at most a few toasts and drops the oldest WITHOUT calling
 * its `onClose`, so a pending removal also commits this long after the window ends. Whichever of
 * the two runs first commits; the other is a no-op.
 */
export const COMMIT_BACKSTOP_MS = 1000;
